import CollectionCardAction from "./collection-card-action";

export default CollectionCardAction;